import Map from "./functional";
export default Map;
